import {
  Component, Input, Output, EventEmitter, ViewChild,
} from '@angular/core';

import { ActiveFilterModel } from 'shared/search/active-filters/active-filter.model';
import { SearchInputComponent } from 'shared/search/search-input/search-input.component';
import { ProductAdvancedSearchComponent } from 'shared/product/product-advanced-search/product-advanced-search.component';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'my-products-search',
  templateUrl: 'my-products-search.component.html',
  styleUrls: ['my-products-search.component.scss'],
})
export class MyProductsSearchComponent {

  showAdvancedSearch: boolean = false;

  @Input() filters: Array<ActiveFilterModel>;
  @Input() searchService: any;
  @Input() hasAdvancedSearch: boolean = false;
  @Input() ghostValue: string;
  @Input() searchModel: any;
  @Input() advancedSearchStatus: string;
  @Input() searchResultsColumns: any;

  @Output() advancedSearchRun: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchCancel: EventEmitter<any> = new EventEmitter();
  @Output() searchValueChanged: EventEmitter<any> = new EventEmitter();
  @Output() clearSearchClick: EventEmitter<any> = new EventEmitter();
  @Output() filterRemove: EventEmitter<any> = new EventEmitter();

  @ViewChild(SearchInputComponent, {static: false})
  searchInput: SearchInputComponent;

  @ViewChild(ProductAdvancedSearchComponent, {static: false})
  advancedSearch: ProductAdvancedSearchComponent;

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get searchModelFilters(): Array<ActiveFilterModel> {
    return this.searchModel.filters;
  }

  get searchInputValue(): string {
    return this.searchInput.searchTermValue;
  }

  public resetSearchValue(value: string) {
    this.searchInput.resetValue(value);
  }

  /*******************************************
   * COMPONENT EVENT HANDLERS
   *******************************************/

  onAdvancedSearchClick() {
    this.showAdvancedSearch = !this.showAdvancedSearch;
  }

  onAdvancedSearchRun() {
    this.advancedSearchRun.emit();
  }

  onAdvancedSearchCancel() {
    this.advancedSearchCancel.emit();
  }

  onSearchValueChanged(event: any) {
    this.searchValueChanged.emit(event);
  }

  onClearSearchClick() {
    this.clearSearchClick.emit();
  }

  onFilterRemove(event: any) {
    this.filterRemove.emit(event);
  }
}
